module.exports = __webpack_public_path__ + "static/passport_white-3a28ef0575bfb05d46f964530643143b.png";